import React, { useState } from 'react'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'

const Countuppage4 = () => {
        const [counterStart, setCounterStart] = useState(false);


  return (
    <>
    <ScrollTrigger onEnter={()=> setCounterStart(true) } onExit={()=>setCounterStart(false)}>

            <h1 className="bold-2">
                {counterStart && <CountUp start={0} end={25} duration={1} delay={0} />}
                
                +
            </h1>
    </ScrollTrigger>


    </>
  )
}

export default Countuppage4
